export const GOOGLE_FORM_OTHER_POSTFIX = '.other_option_response';
export const GOOGLE_FORM_YEAR_POSTFIX = '_year';
export const GOOGLE_FORM_MONTH_POSTFIX = '_month';
export const GOOGLE_FORM_DAY_POSTFIX = '_day';

const datePrefix = 'date:';
/** checks if form value is a date value */
export const isDateValue = (value: string) => value.startsWith(datePrefix);
/** gets date from date value */
export const getDateValue = (value: string) => value.replace(datePrefix, '');
/** makes date value from value */
export const setDateValue = (value: string) => `${datePrefix}${value}`;
const otherPrefix = 'other:';
/** checks if form value is a other value */
export const isOtherValue = (value: string) => value.startsWith(otherPrefix);
/** gets other info from other value */
export const getOtherValue = (value: string = '') => {
    if (!isOtherValue(value)) return { value, isOther: false };
    const [, isOther, val = ''] = value.split(':');
    return {
        value: val,
        isOther: isOther === 'true',
    };
};
/** makes other value from value */
export const setOtherValue = (value: string, isOther = false) => `${otherPrefix}${isOther}:${value}`;
